// import extractSizesAssociatedToColor from '../../components/add-to-cart-alt/extractSizesAssociatedToColor';
import { filtered_products } from './filteredCollection';
import { getSizedImageURL } from '../../core/images';

const getProductJson = (tile) => {
  const is_search = document.body.classList.contains('has-overlay-search');
  let product_json = null;

  if (is_search) {
    product_json = window.theme.search.products;
  } else if (document.body.classList.contains('template-plp')) {
    // Can have multiple same product id on sliced products
    product_json = Array.from(filtered_products).filter(
      product => String(product.product_id) === String(tile.dataset.productId)
    );
  } else if (document.body.className.includes('lookbook')) {
    product_json = window.theme.lookbook_products.find(
      product => product.handle === tile.dataset.productHandle
    );
  } else {
    const product_list = window.theme.collections.data.find(
      collection => collection.handle === 'product-list'
    );
    if (product_list && Array.isArray(product_list.products)) {
      product_json = product_list.products.filter(
        product => product.id === Number(tile.dataset.productId)
      );
    }
  }

  return product_json;
};

// Update the flag if there's a variant metafield flag is available, else we restore the default flag
// Priority: Best Seller app flag > Trending app flag > Style metafield flag > Tag-based flag
const updateTileFlag = (product_json, swatch) => {
  const tile = swatch.closest('.product-tile');

  if (!tile.querySelector('.product-tile__flags')) {
    return;
  }

  const color_value = swatch.dataset.colorValue;
  // const p_json = (Array.isArray(product_json)) ? _.find(product_json, { skus: [{ color_value }] }) : product_json;
  const p_json = Array.isArray(product_json)
    ? product_json.flatMap(product => product.skus.filter(sku => sku.custom_fields?.Color === color_value))
    : Array.isArray(product_json?.skus)
      ? product_json.skus.filter(sku => sku.custom_fields?.Color === color_value)
      : [];

  if (typeof p_json === 'undefined' || p_json === null) {
    return;
  }

  const is_plus = color_value.includes('Plus Size -');

  // We don't have the value on a single size anymore
  // Find the 1st value of the metafield tag if any
  const flag_standard_size_value = p_json.find(sku => sku.custom_fields?.['astr-style_flag'])?.custom_fields?.['astr-style_flag'] ?? '';
  const flag_plus_size_value = p_json.find(sku => sku.custom_fields?.['astr-style_flag_plus_sizes'])?.custom_fields?.['astr-style_flag_plus_sizes'] ?? '';
  const flag_custom_value = (flag_standard_size_value === '' && flag_plus_size_value === '') ? '' : (is_plus) ? flag_plus_size_value : flag_standard_size_value;

  const flags_container = tile.querySelector('.product-tile__flags');
  // Query all matches (not just the first) so any stray/duplicate flag left over from a
  // previous selection is always cleaned up instead of silently staying visible.
  const default_flags = Array.from(flags_container.querySelectorAll('.product-tile__flag--tag, .product-tile__flag--app'));
  const custom_flags = Array.from(flags_container.querySelectorAll('.product-tile__flag--custom'));

  // Can be different by style - will need to be re-created
  custom_flags.forEach((flag) => flag.remove());

  if (flag_custom_value === '') {
    // Show the default flag(s)
    default_flags.forEach((flag) => { flag.classList.remove('visually-hidden'); flag.removeAttribute('aria-hidden'); });
  } else {
    // Create and show the custom tag if no app flag / Hide the tag-based flag.
    // .visually-hidden alone isn't enough here: it's a sr-only clip technique,
    // so the hidden flag's text stays exposed to assistive tech and gets
    // stacked together with the newly appended custom flag's text in the
    // accessible name computation. aria-hidden fully excludes it.
    default_flags.forEach((flag) => { flag.classList.add('visually-hidden'); flag.setAttribute('aria-hidden', 'true'); });

    const custom_flag_element = document.createElement('div');
    custom_flag_element.classList.add('product-tile__flag');
    custom_flag_element.classList.add('product-tile__flag--custom');
    custom_flag_element.innerHTML = flag_custom_value;
    flags_container.appendChild(custom_flag_element);
  }
};

const syncTileImageAriaLabel = (tile) => {
  const imageLink = tile.querySelector('[data-product-tile-image]');
  if (!imageLink) {
    return;
  }

  const titleElement = tile.querySelector('[data-product-tile-title] a span, [data-product-tile-title] a');
  const titleText = (titleElement?.textContent || '').trim();
  const fallbackLabel = (imageLink.getAttribute('aria-label') || '').trim();
  const baseLabel = titleText || fallbackLabel;

  if (!baseLabel) {
    return;
  }

  const visibleFlag = Array.from(tile.querySelectorAll('.product-tile__flags .product-tile__flag'))
    .find((flag) => !flag.classList.contains('visually-hidden') && flag.getAttribute('aria-hidden') !== 'true' && flag.textContent && flag.textContent.trim() !== '');
  const flagText = visibleFlag ? visibleFlag.textContent.trim() : '';

  imageLink.setAttribute('aria-label', flagText ? `${baseLabel} ${flagText}` : baseLabel);
};

const selectSwatch = (item) => {
  if (item.classList.contains('active')) {
    return;
  }

  const tile = item.closest('.product-tile');
  const tile_image = tile.querySelector('[data-product-tile-image]');
  const selected_first_variant_id = parseInt(item.dataset.variantId, 10);
  // const is_search = document.querySelector('body').classList.contains('has-overlay-search');
  const tile_id = tile.id;
  const tile_pos = (tile_id) ? Number(tile_id.replace('product-tile-', '')) : null;

  Array.from(tile.querySelectorAll('[data-color-swatch]')).forEach((element) => {
    element.classList.remove('active');
    element.setAttribute('aria-pressed', 'false');
  });
  item.classList.add('active');
  item.setAttribute('aria-pressed', 'true');

  // Reset the horizontal image slider back to the first image on mobile
  const slider = tile.querySelector('.product-tile__images-slider');
  if (slider) {
    slider.scrollLeft = 0;
  }

  let image_class = '';
  let image_wrapper = '';
  if (tile_image.querySelector('.responsive-image__wrapper') !== null) {
    image_class = 'responsive-image__image';
    image_wrapper = ' .responsive-image__wrapper';
  }

  // const placeholder = 'https://cdn.shopify.com/s/files/1/2483/6632/files/product-tile-bkg.gif?v=1611803919';
  const placeholder = window.theme.collections.placeholder;

  // Load the new images (sizes are defined in collection-grid-swatch.liquid)
  if (typeof item.dataset.front !== 'undefined' && item.dataset.front !== '' && !item.dataset.front.includes('<svg')) {
    // $tile_image.find(`[data-product-main-image]${image_wrapper}`).addClass('hidden-when-not-loaded').html(`<img src="${$item.data('front').replace('300x460', '1x460')}" data-src="${$item.data('front')}" alt="${$tile.find('[data-product-tile-title] a').text()} - ${$item.data('color-value')} - Front" class="lazyload blur-up ${image_class}" />`);

    let front_url = item.dataset.front;
    if (front_url && !front_url.startsWith('https://')) {
      if (front_url.startsWith('//')) {
        front_url = 'https:' + front_url;
      } else if (!front_url.startsWith('http')) {
        front_url = 'https://' + front_url.replace(/^\/+/, '');
      }
    }

    // Remove querystring
    front_url = front_url.split('?')[0];

    let front_img_src = (front_url.includes('crop=center')) ? front_url : getSizedImageURL(front_url, '600x920_crop_center');

    if (front_img_src) {
      // Don't lazy load the product images above the fold
      let loading_type = 'lazy';
      if (tile_pos !== null) {
        loading_type = (tile_pos <= 5) ? 'eager' : 'lazy';
      }
      // let front_img_src = $item.data('front');

      // const front_img_placeholder_src = getSizedImageURL($item.data('front'), '1x_crop_center');
      // const front_img_placeholder_src = 'https://cdn.shopify.com/s/files/1/2483/6632/files/pixel-grey.png?v=1687192560';
      // front_img_src = progressiveJpg($item.data('front'));
      // https://cdn.shopify.com/s/files/1/2483/6632/products/ADR101502_SILVERFLORAL_1_300x460_crop_center@2x.jpg?v=1678350907
      // let img_dimensions = `width="300" height="460"`;
      // if (window.theme.breakpoints.current === 'mobile') {
      //   front_img_src = front_img_src.replace('300x460', '150x230');
      //   img_dimensions = `width="150" height="230"`;
      // }

      // We need the original src for comparison purpose (find the video associated to the image)
      // tile_image.querySelector(`[data-product-main-image]${image_wrapper}`).innerHTML = `<img loading="lazy" src="${front_img_src}" alt="${item.dataset.frontAlt}" class="${image_class}" ${img_dimensions} data-original-src="${item.dataset.front}" onError="this.src = '${placeholder}';" />`;

      // IMPORTANT: Don't forget to update the image within productTileTemplateNosto.js

      if (window.theme.breakpoints.current === 'mobile') {
        front_img_src = getSizedImageURL(front_url, '180x276_crop_center');
        // img_dimensions = `width="180" height="276"`;

        tile_image.querySelector(`[data-product-main-image]${image_wrapper}`).innerHTML = `
          <img
            loading="${loading_type}"
            src="${front_img_src}"
            srcset="
              ${getSizedImageURL(front_url, '90x138_crop_center')} 90w,
              ${getSizedImageURL(front_url, '180x276_crop_center')} 180w,
              ${getSizedImageURL(front_url, '250x383_crop_center')} 250w,
              ${getSizedImageURL(front_url, '400x613_crop_center')} 400w,
              ${getSizedImageURL(front_url, '450x690_crop_center')} 450w,
              ${getSizedImageURL(front_url, '500x767_crop_center')} 500w,
              ${getSizedImageURL(front_url, '700x1073_crop_center')} 700w,
              ${getSizedImageURL(front_url, '800x1200_crop_center')} 800w
            "
            sizes="180px"
            alt="${item.dataset.frontAlt}"
            class="${image_class}"
            width="180" height="276"
            data-original-src="${front_url}"
            onError="this.onerror=null; this.src='${placeholder}'; this.srcset='';"
          />
        `;
      } else {
        tile_image.querySelector(`[data-product-main-image]${image_wrapper}`).innerHTML = `
          <img
            loading="${loading_type}"
            src="${getSizedImageURL(front_url, '600x915_crop_center')}"
            srcset="
              ${getSizedImageURL(front_url, '400x613_crop_center')} 400w,
              ${getSizedImageURL(front_url, '500x767_crop_center')} 500w,
              ${getSizedImageURL(front_url, '600x915_crop_center')} 600w,
              ${getSizedImageURL(front_url, '800x1226_crop_center')} 800w,
              ${getSizedImageURL(front_url, '1000x1533_crop_center')} 1000w
            "
            sizes="(min-width: 1024px) 25vw, 400px"
            alt="${item.dataset.frontAlt}"
            class="${image_class}"
            width="600" height="915"
            data-original-src="${front_url}"
            data-new-color-selected="true"
            onError="this.onerror=null; this.src='${placeholder}'; this.srcset='';"
          />
        `;
      }

      // $tile_image.find(`[data-product-main-image]${image_wrapper}`).css({'background-image': `url(${$item.data('front').replace('300x460', '1x1')})`, 'background-size': '100%'});
      // $tile_image.find(`[data-product-main-image]${image_wrapper}`).css({'background-image': `url(${placeholder})`, 'background-size': '100%'});
    }
  }

  if (typeof item.dataset.back !== 'undefined' && item.dataset.back !== '' && tile_image.querySelector('[data-product-alt-image]') !== null) {
    let back_url = item.dataset.back;
    if (back_url && !back_url.startsWith('https://')) {
      if (back_url.startsWith('//')) {
        back_url = 'https:' + back_url;
      } else if (!back_url.startsWith('http')) {
        back_url = 'https://' + back_url.replace(/^\/+/, '');
      }
    }
    // Remove querystring
    back_url = back_url.split('?')[0];

    // const back_size_desktop = '300x460_crop_center@2x.progressive';
    const back_img_src = (item.dataset.back.includes('crop=center')) ? back_url : getSizedImageURL(back_url, '600x920_crop_center');
    // let back_img_src = $item.data('back');

    if (back_img_src) {
      // const back_img_placeholder_src = getSizedImageURL($item.data('back'), '20x_crop_center@2x.progressive');
      // const back_img_placeholder_src = 'https://cdn.shopify.com/s/files/1/2483/6632/files/pixel-grey.png?v=1687192560';
      // let back_img_dimensions = `width="300" height="460"`;
      // const back_img_src = progressiveJpg($item.data('back'));
      // if (window.theme.breakpoints.current === 'mobile') {
      //   back_img_src = back_img_src.replace('300x460', '150x230');
      //   back_img_dimensions = `width="150" height="230"`;
      // }

      // if (window.theme.breakpoints.current === 'mobile') {
      //   back_img_src = getSizedImageURL(back_url, '150x230_crop_center');
      //   back_img_dimensions = `width="150" height="230"`;
      // }

      // tile_image.querySelector(`[data-product-alt-image]${image_wrapper}`).innerHTML = `<img src="${back_img_src}" alt="${item.dataset.backAlt}" class="${image_class}" ${back_img_dimensions} onError="this.src = '${placeholder}';" />`;

      if (window.theme.breakpoints.current === 'mobile') {
        tile_image.querySelector(`[data-product-alt-image]${image_wrapper}`).innerHTML = `
          <img
            loading="lazy"
            src="${back_img_src}"
            srcset="
              ${getSizedImageURL(back_url, '90x138')} 90w,
              ${getSizedImageURL(back_url, '180x276')} 180w,
              ${getSizedImageURL(back_url, '250x383')} 250w,
              ${getSizedImageURL(back_url, '400x613')} 400w,
              ${getSizedImageURL(back_url, '450x690')} 450w,
              ${getSizedImageURL(back_url, '500x767')} 500w,
              ${getSizedImageURL(back_url, '700x1073')} 700w,
              ${getSizedImageURL(back_url, '800x1200')} 800w
            "
            width="180" height="276"
            alt="${item.dataset.backAlt}"
            class="${image_class}"
            onError="this.onerror=null; this.src = '${placeholder}'; this.srcset='';"
          />
        `;
      } else {
        tile_image.querySelector(`[data-product-alt-image]${image_wrapper}`).innerHTML = `
          <img
            loading="lazy"
            src="${back_img_src}"
            srcset="
              ${getSizedImageURL(back_url, '400x613_crop_center')} 400w,
              ${getSizedImageURL(back_url, '500x767_crop_center')} 500w,
              ${getSizedImageURL(back_url, '600x915_crop_center')} 600w,
              ${getSizedImageURL(back_url, '800x1226_crop_center')} 800w,
              ${getSizedImageURL(back_url, '1000x1533_crop_center')} 1000w
            "
            sizes="(min-width: 1024px) 25vw, 400px"
            alt="${item.dataset.backAlt}"
            class="${image_class}"
            width="600" height="915"
            onError="this.onerror=null; this.src = '${placeholder}'; this.srcset='';"
          />
        `;
      }
    }
  }

  // Change the product url
  const original_url = tile.dataset.productUrl;
  let new_url = original_url;
  if (typeof new_url !== 'undefined') {
    new_url += new_url.includes('?') ? '&' : '?';
    new_url += `color=${item.dataset.colorValue}`;
    new_url += `&variant=${item.dataset.variantId}`;

    const image_link = tile.querySelector('[data-product-tile-image]');
    if (image_link) {
      image_link.setAttribute('href', new_url);
    }

    const title_link = tile.querySelector('[data-product-tile-title] a');
    if (title_link) {
      title_link.setAttribute('href', new_url);
    }

    const rating_link = tile.querySelector('[data-product-tile-rating]');
    if (rating_link) {
      rating_link.setAttribute('href', new_url + '#pdp-reviews-anchor');
    }
  }

  /** Add to cart alt - START **/
  // Lookbook pages, reinit add to cart button
  // if ($tile.parent().hasClass('gallery-products-carousel__products')) {
  // $tile.find('[data-add-to-cart-alt-button]').html(`<span>${window.theme.strings.addToCart}</span>`);

  const product_json = getProductJson(tile);

  // Don't forget to update the code for the desktop version in components/add-to-catr-alt/index.js
  if (window.theme.breakpoints.current === 'mobile' || window.theme.breakpoints.current === 'tablet') {
    // Preselect the 1st size available
    window.setTimeout(() => {
      const available_sizes = tile.querySelectorAll('[data-size-button].available');
      if (available_sizes.length > 0) {
        const first_available_size = available_sizes[0];
        // $first_available_size.addClass('active'); // not sure why this doesn't work
        tile.querySelector('[data-add-to-cart-alt-button]').dataset.selectedVariantId = first_available_size.dataset.variantId;
      }
    }, 1);
  }
  // }

  /** Add to cart alt - END **/

  // Update the wishlist button; video if any
  const wishlist_event = new CustomEvent('tile-variant:change', { bubbles: true });
  wishlist_event.data = { detail: { variantId: selected_first_variant_id, tile: $(tile) } };
  document.dispatchEvent(wishlist_event);

  updateTileFlag(product_json, item);
  syncTileImageAriaLabel(tile);

  tile.classList.add('init');
};

const initSelectNewColor = () => {
  // Can be initialized from sevaral parts (PLP, search overlay, recommendation lists...)
  if (window.select_new_color_init === true) {
    return;
  }

  window.select_new_color_init = true;

  $(document).on('click touchend', '[data-product-tile] [data-color-swatch]', (e) => {
    e.stopPropagation();
    e.preventDefault();

    selectSwatch(e.currentTarget);
  });

  $(document).on('keypress', '[data-product-tile] [data-color-swatch]', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      const item = e.currentTarget;
      e.preventDefault();
      item.click();
    }
  });
};

export {
  initSelectNewColor,
  selectSwatch,
};
